/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_CINEMAS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, ILocation } from '../../api/types';

export type CinemasState = ICommonResponse<ILocation>;

const initialState = {} as ICommonResponse<ILocation>;
const generic = genericReducers<CinemasState>();
const cinemas: IReducers<CinemasState> = {
  [GET_CINEMAS[REQUEST]]: generic.get.request,
  [GET_CINEMAS[SUCCESS]]: generic.get.success,
  [GET_CINEMAS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, cinemas);
